/**
 * This file helps us store transaction data temporarly in the browser session storage while we wait for
 * the user to visit the 3DS site and then come back to us. The transaction data is deleted as soon as
 * the transaction is completed, or after 1 hour if the transaction stalls.
 */
import { Transaction } from './types/Transaction';

const sessionStorageKey = 'chase3dsCurrentTransaction';
const cardDataExperationSeconds = 60 * 60; // One hour

const getCurrentTimeStampSeconds = (): number => {
    return Math.floor(Date.now() / 1000);
};

export const setCurrentTransactionData = (transactionData: Transaction) => {
    window.sessionStorage.setItem(sessionStorageKey,
        btoa(JSON.stringify({
            expirationTimestamp: getCurrentTimeStampSeconds() + cardDataExperationSeconds,
            transactionData,
        }))
    );
};

export const getCurrentTransactionData = (): Transaction | null => {
    deleteExpiredTransactionData();
    const json = window.sessionStorage.getItem(sessionStorageKey);
    if (!json) {
        return null;
    }
    return JSON.parse(atob(json)).transactionData;
};

export const deleteCurrentTransactionData = () => {
    window.sessionStorage.removeItem(sessionStorageKey);
};

export const deleteExpiredTransactionData = (): void => {
    const json = window.sessionStorage.getItem(sessionStorageKey);
    if (!json) {
        return;
    }
    if (getCurrentTimeStampSeconds() > JSON.parse(atob(json)).expirationTimestamp) {
        deleteCurrentTransactionData();
    }
};
